// extracted by mini-css-extract-plugin
module.exports = {"daysOfWeek":"DaysOfWeek-daysOfWeek-sW6qm"};